import { createSlice } from '@reduxjs/toolkit';

let counter = 0;

const initialState = {
  toasts: /** @type {{id: string, variant: 'success'|'info'|'warning'|'error', message: string, createdAt: number}[]} */ ([]),
  previewMode: false,
};

const slice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    toastShown: {
      reducer(state, action) {
        state.toasts.push(action.payload);
      },
      prepare({ variant, message }) {
        counter += 1;
        return {
          payload: {
            id: `${Date.now()}-${counter}`,
            variant,
            message,
            createdAt: Date.now(),
          },
        };
      },
    },
    toastDismissed(state, action) {
      state.toasts = state.toasts.filter((t) => t.id !== action.payload);
    },
    previewModeEnabled(state) {
      state.previewMode = true;
    },
    previewModeDisabled(state) {
      state.previewMode = false;
    },
  },
});

export const { toastShown, toastDismissed, previewModeEnabled, previewModeDisabled } = slice.actions;
export const toastReducer = slice.reducer;
